export const en = {
  // Header/Sidebar
  user: 'User',
  users: 'Users',
  installations: 'Installations',
  settings: 'Settings',
  certificate: 'Certificate',
  main_settings: 'Main Settings',
  terminology: 'Terminology',
  equipment: 'Equipment',
  security: 'Security',
  tenants: 'Tenants',
  collapse: 'Collapse',
  branding: 'Branding',
  sign_out: 'Sign Out',
  hello: 'Hello!',
  reports: "Reports",

  // Misc
  save: 'Save',
  cancel: 'Cancel',

  // Installation Table
  status: 'Status',
  clear: 'Clear',
  date: 'Date',
  technician: 'Technician',
  customer_phone: 'Customer Phone',
  address: 'Address',
  unit: 'Unit',
  city: 'City',
  state_prov: 'State/Prov',
  rooms_tested: 'Rooms Tested',
  tested: 'Tested',
  plan: 'Plan',
  rows_per_page: 'Rows per page: ',
  recommended_short: 'Recomm.',
  notes: 'Notes',

  // Certificate Branding Tab
  current_image: 'Current Image: ',
  using_default_logo: 'Using Default Logo',
  new_image: 'New Image',
  branding_loading_error: 'Branding loading error. Please try again later.',
  upload_new_image: 'Upload New Image',
  clear_custom_image: 'Clear Custom Image',
  clear_custom_color: 'Clear Custom Color',
  brand_color: 'Brand Color',
  header_message: 'Header Message',
  header_education_message: 'Header Education Message',
  footer_education_message: 'Footer Education Message',
  preview: 'Preview',
  file_must_be_less_than_size_limit: 'File must be less than 30KB',

  // Certificate Headers
  congrats_message: "Your WiFi installation is complete and has been certified by RouteThis!",
  installation_details: "Installation Details",
  wireless_speed_test: "Wireless Speed Test",
  wireless_speed_test_hidespeedtest: "WiFi Internet Speed Test",
  wireless_performance: "Wireless Performance",
  photos: "Photos",
  signal_maps: "Signal Maps",
  wifi_information: 'WiFi Information',

  // Certificate Room Names
  singular_room: "Room",
  room_type_bathroom: "Bathroom",
  room_type_bedroom: "Bedroom",
  room_type_dining_room: "Dining Room",
  room_type_entry_or_hall: "Entry/Hall",
  room_type_garage: "Garage",
  room_type_kitchen: "Kitchen",
  room_type_living_room: "Living Room",
  room_type_office: "Office",
  room_type_other: "Other",

  // Pod Name
  pod_1: "Mesh Pod",
  pod_2: "Access Point",
  pod_3: "Mesh Node",
  pod_4: "Mesh Puck",
  pod_5: "Beacon",
  pod_6: "Range Extender",
  pods_1: "Mesh Pods",
  pods_2: "Access Points",
  pods_3: "Mesh Nodes",
  pods_4: "Mesh Pucks",
  pods_5: "Beacons",
  pods_6: "Range Extenders",

  // Router Name
  router_1: "Router",
  router_2: "Modem",
  router_3: "Gateway",
  router_4: "Hub",
  router_5: "Residential Gateway",

  // Level Name
  level_1: "Level",
  level_2: "Floor",
  levels_1: "Levels",
  levels_2: "Floors",

  // a11y Labels
  go_to_homepage: 'Go To Homepage',
  edit_user_x: 'Edit User [X]',
  open_certificate_for_addr: 'Open Certificate For [ADDR]',
  clear_all_filters: 'clear all filters',
  expand_sidebar: 'Expand Sidebar',
  current_tenant_branding_image: 'Current Tenant Branding Image',
  new_tenant_branding_image: 'New Tenant Branding Image',

  // Certificate Pod Info
  recommended: "Recommended",
  installed: "Installed",
  installed_singular: "Installed",
  total: "Total",

  // Certificate Signal Table
  front_building: "Front of Building",
  speed: "Speed",
  video: "Video",
  rssi: "RSSI",
  rssi_description: "dBm",
  link: "Link",
  frequency_short: "Freq.",
  frequency_description: "MHz",
  channel_short: "Ch.",

  // Certificate Legend
  legend: "Legend",
  measured_speed: "Measured Speed",
  measured_speed_description: "Mbps",
  plan_speed: "Plan Speed",

  // Certificate Speedtest Result
  speedtest_passed: "Speed is within the expected range for most mobile devices. Not all wireless devices are capable of reaching maximum plan speed. See below for individual room tests.",
  speedtest_passed_hidespeedtest: "Verified internet connection speed for your plan.",
  speedtest_failed: "Tested on a phone or tablet. Not all wireless devices are capable of reaching maximum plan speed. See below for individual room tests.",
  speedtest_24ghz: "Speedtest was run on 2.4GHz band; slow speed recorded.",
  speedtestmessages_strong: "Speed is within the expected range for most mobile devices.",
  speedtestmessages_weak: "Speed is far below the expected range for most mobile devices.",
  speedtestmessages_medium: "Speed is below the expected range for most mobile devices.",
  wifi_activities_highspeed_videos: "Multiple 4K Videos",
  wifi_activities_highspeed_conferencing: "Video Conferencing",
  wifi_activities_highspeed_gaming: "Online Gaming",
  wifi_activities_highspeed_music: "Streaming Music",
  wifi_activities_lowspeed_conferencing: "Video Conferencing",
  wifi_activities_lowspeed_gaming: "Online Gaming",
  wifi_activities_lowspeed_music: "Streaming Music",
  wifi_activities_lowspeed_email: "Email & Social Media",
  speedTestIndicatorText_weak: "Poor WiFi Speed",
  speedTestIndicatorText_medium: "Slower WiFi Speed",
  speedTestIndicatorText_strong: "Optimal WiFi Speed",
  signal_coverage: "Signal Coverage",
  signaltablemessage_title: "Activities are arranged left to right by required signal strength.",
  signaltablemessage_subtitle: "If you can perform an activity in the indicated room, you can also perform all activities to its right.",
  alerts: "Alerts",
  alertMessages_bandAlert: "Speedtest was run on 2.4GHz band; slow speed recorded.",
  alertMessages_lowSignalAlert: "Your connection here will be stable and allow you to browse both email and social media, but you will not experience the speeds available in other parts of your home.",
  alertMessages_veryLowSignalAlert: "Your signal strength is very poor. You may experience slow loading times and interruptions. For a better experience, move to a different part of your home where the signal is stronger.",
  alertMessages_noAlert: "No alerts on this level!",
  alertmessages_lowPodsAlert: "Since not all the recommended pods were installed, you may experience a reduction in speeds as you get farther away from the router.",
  customLowPodsAlertString: "Since not all the recommended %PODSNAME were installed, you may experience a reduction in speeds as you get farther away from the %ROUTERNAME.",


  // Reports Page
  reports_access_error: "Please contact your administrator to see this page",

  // Login/Reset Password
  password: 'Password',
  sign_in: 'Sign In',
  forgot_password: 'Forgot Password',
  reset_password: 'Reset Password',
  reset_password_instructions: "To reset your password, enter your email address above and we'll send instructions, if the account exists.",
  sent_reset_password_code: 'We sent a password reset code to [email] Enter that code and a new password.',
  reset_code: 'Reset Code',
  new_password: 'New Password',
  reenter_new_password: 'Re-enter New Password',
  must_include_email: 'Must include email',
  old_password: 'Old Password',
  set_new_password: 'Set New Password',
  password_expired: 'Password Expired',
  toggle_password_visibility: 'Toggle password visibility',
  change_your_password: 'Change Your Password',
  change_password: 'Change Password',
  set_password: 'Set Password',

  // Users List
  new_user: 'New User',
  edit_user: 'Edit User',
  bulk_import: 'Bulk Import',
  bulk_import_users: 'Bulk Import Users',
  show_disabled_users: 'Show Disabled Users',
  name: 'Name',
  role: 'Role',
  roles: 'Roles',
  location: 'Location',
  group: 'Group',
  manager: 'Manager',
  download_bulk_template: 'Download Bulk Template',
  user_id_email: 'User ID (email)',

  // Valid User roles
  user_role: 'user',
  tenant_admin_role: 'TenantAdmin',
  super_admin_role: 'SuperAdmin',
  tenant_admin: 'Tenant Admin',
  super_admin: 'Super Admin',

  // Create/Edit User Modal
  email_required: 'Email (Required)',
  first_name: 'First Name',
  last_name: 'Last Name',
  force_password_reset: 'Force Password Reset',
  resend_validation_code: 'Resend Validation Code',
  enable_user: 'Enable User',
  disable_user: 'Disable User',
  certify: 'Certify',
  unverified: 'Unverified',
  locked_out: 'Locked Out',
  disabled: 'Disabled',
  reset_user_password_confirmation: "Are you sure you want to reset this user's password?",
  resend_validation_code_confirmation: 'Are you sure you want to resend validation code?',
  cannot_disable_yourself: 'Cannot disable yourself',
  cancel_changes: 'Cancel changes',

  // Snackbar Messages
  snackbar_disable_success : 'Successfully disabled user:',
  snackbar_disable_error : 'Error disabling user:',
  snackbar_enable_success : 'Successfully enabled user:',
  snackbar_enable_error : 'Error enabling user:',
  snackbar_password_reset_success : 'Successfully reset the password for user:',
  snackbar_password_reset_error: 'Error resetting the password for user:',

  // Bulk Import Modal
  csv_format_requirements: 'Your CSV Format needs to be formatted properly. If you are unsure of the format You can also',
  csv_format_download_link: 'download a template file here.',
  
  csv_format_error: "We couldn't process your uploaded file, please ensure that your file is in the correct format and includes the 'email' and 'manager_0' headers.",
  select_csv: 'Browse CSV file',
  import: 'Import',
  file_too_large: 'File too large (Maximum of IMPORT_LIMIT users)',
  required_headers_missing: 'Required headers missing: email',
  user_import_starting: 'User import starting. You will receive an import summary email in a few minutes.',
  change_file: 'Change File',

  // Bulk Import Messaging
  bulk_processing_1: 'We are processing the file:',
  bulk_processing_2: "As soon as we're done, we'll send you an email with all the details.",
  bulk_complete_1: "Completed:",
  bulk_complete_2: "is now uploaded.",
  bulk_error: "An error occurred and your file did not upload to the server. Please check your email for details.",
  bulk_thanks_header: 'Thanks for uploading your file!',
  bulk_thanks_content: "We're working on processing it now, and as soon as we're done, we'll send you an email with all the details. You can also keep an eye on the app for updates on you file's status.",

  // Tenant Main Settings
  email_language: 'Email Language',
  country: 'Country',
  description_optional: 'Description (Optional)',
  units_feet_meters: 'Units (Feet, Meters)',
  certify_id: 'Certify ID',
  resolve_id: 'Resolve ID',
  sms_settings: 'SMS Settings',
  udp_flood_settings: 'UDP Flood Settings',
  udp_flood_settings_absolute_ideal: 'PASS If the UDP Flood speed is greater than (Mbps)',
  udp_flood_settings_absolute_minimum: 'WARN If the UDP Flood speed is greater than (Mbps) ',
  udp_flood_settings_plan_multiple: 'PASS If the UDP Flood speed is greater than (times the plan speed/max speed)',
  udp_flood_settings_absolute_plan_percentage: 'WARN If the UDP Flood speed is greater than (% of the plan speed/max speed)',
  sms_from: 'SMS From',
  sms_body: 'SMS Body',
  default_sms_body: 'Your WiFi installation is complete and has been certified by [NAME]! \n View your certificate here: [LINK]',
  sms_body_helper_text: 'Certify will text this message to the customer. [LINK] will be replaced with a link to the certificate (required). [NAME] will be replaced with the contents of the Name field (optional)',
  link_must_be_in_sms_body: '[LINK] must be in the SMS body.',
  mobile_settings: 'Mobile Settings',
  custom_id_required: 'Custom ID Required',
  update_successful: 'Update Successful',
  creation_successful: 'Creation Successful',

  // Tenant Terminology Settings
  term: 'Term',
  example_usage: 'Example Usage',
  customer_example_usage_1: 'In consultation with the customer, confirm the selected building, or go back to edit the address.',
  customer_example_usage_2: 'In consultation with the subscriber, confirm the selected building, or go back to edit the address.',
  router_example_usage_1: 'Tap the proposed router location below.',
  router_example_usage_2: 'Tap the proposed modem location below.',
  router_example_usage_3: 'Tap the proposed gateway location below.',
  router_example_usage_4: 'Tap the proposed hub location below.',
  router_example_usage_5: 'Tap the proposed residential gateway location below.',
  level_example_usage_1: 'Go to level 2 and tap your location.',
  level_example_usage_2: 'Go to floor 2 and tap your location.',
  mesh_pod_example_usage_1: 'Estimating signal strength and optimum mesh pod placement.',
  mesh_pod_example_usage_2: 'Estimating signal strength and optimum access point placement.',
  mesh_pod_example_usage_3: 'Estimating signal strength and optimum mesh node placement.',
  mesh_pod_example_usage_4: 'Estimating signal strength and optimum mesh puck placement.',
  mesh_pod_example_usage_5: 'Estimating signal strength and optimum beacon placement.',
  mesh_pod_example_usage_6: 'Estimating signal strength and optimum range extender placement.',
  wifi_example_usage_1: 'WiFi Mapping',
  wifi_example_usage_2: 'Wi-Fi Mapping',
  wifi_example_usage_3: 'Wifi Mapping',
  wifi_example_usage_4: 'WIFI Mapping',

  // Tenant Equipment Settings (Certify)
  router_options_1: 'Router Options',
  router_options_2: 'Modem Options',
  router_options_3: 'Gateway Options',
  router_options_4: 'Hub Options',
  router_options_5: 'Residential Gateway Options',
  new_router_options_1: 'New Router Options',
  new_router_options_2: 'New Modem Options',
  new_router_options_3: 'New Gateway Options',
  new_router_options_4: 'New Hub Options',
  new_router_options_5: 'New Residential Gateway Options',
  mesh_pod_options_1: 'Mesh Pod Options',
  mesh_pod_options_2: 'Access Point Options',
  mesh_pod_options_3: 'Mesh Node Options',
  mesh_pod_options_4: 'Mesh Puck Options',
  mesh_pod_options_5: 'Beacon Options',
  mesh_pod_options_6: 'Range Extender Options',
  new_mesh_pod_options_1: 'New Mesh Pod Options',
  new_mesh_pod_options_2: 'New Access Point Options',
  new_mesh_pod_options_3: 'New Mesh Node Options',
  new_mesh_pod_options_4: 'New Mesh Puck Options',
  new_mesh_pod_options_5: 'New Beacon Options',
  new_mesh_pod_options_6: 'New Range Extender Options',
  missing_required_router_info_1: 'Missing Required Router Info',
  missing_required_router_info_2: 'Missing Required Modem Info',
  missing_required_router_info_3: 'Missing Required Gateway Info',
  missing_required_router_info_4: 'Missing Required Hub Info',
  missing_required_router_info_5: 'Missing Required Residential Gateway Info',
  missing_required_mesh_pod_info_1: 'Missing Required Mesh Pod Info',
  missing_required_mesh_pod_info_2: 'Missing Required Access Point Info',
  missing_required_mesh_pod_info_3: 'Missing Required Mesh Node Info',
  missing_required_mesh_pod_info_4: 'Missing Required Mesh Puck Info',
  missing_required_mesh_pod_info_5: 'Missing Required Beacon Info',
  missing_required_mesh_pod_info_6: 'Missing Required Range Extender Info',
  display_name: 'Display Name',
  description: 'Description',
  range_in_unit_1: 'Range in Feet',
  range_in_unit_2: 'Range in Meters',
  area_in_unit_1: 'Area in Square Feet',
  area_in_unit_2: 'Area in Square Meters',
  default_active: 'Default Active',
  average_range: 'Average Range',
  certify_default: 'Certify default',
  default: 'Default',
  active: 'Active',
  one_option_must_be_default: 'One option must be default',
  set_as_default: 'Set as default',
  default_option_must_be_active: 'Default option must be active',
  deactivate: 'Deactivate',
  activate: 'Activate',
  name_is_required: 'Name is required',

  // Customer Name
  customer_1: "Customer",
  customer_2: "Subscriber",
  // Wifi Name
  wifi_1: 'WiFi',
  wifi_2: 'Wi-Fi',
  wifi_3: 'Wifi',
  wifi_4: 'WIFI',

  // Units
  units_1: 'Feet',
  units_2: 'Meters',

  // Misc
  confirm: 'Confirm',
  units: 'Units',
  region: 'Region',
  edit: 'Edit',
  modified: 'Modified',
  create: 'Create',
  created: 'Created',
  routethis_app: 'RouteThis App',
  loading: 'Loading...',
  redirecting: 'Redirecting...', 
  error: 'Error',
  close: 'Close',
  search: 'Search', 
  all: 'All',
  dismiss: 'Dismiss',

  // Languages
  en: 'English (US)',
  'en-GB': 'English (GB)',
  da: 'Danish',
  fi: 'Finnish',
  fr: 'French',
  'fr-CA': 'French (Canada)',
  de: 'German',
  el: 'Greek',
  it: 'Italian',
  pt: 'Portuguese',
  'pt-BR': 'Portuguese (Brazil',
  es: 'Spanish',
  'es-419': 'Spanish (Latin America)',
  sv: 'Swedish',
  
}


export const en_errors = {
  // Client-side validation errors
  incorrect_email_or_password: 'Wrong username and password combination or the user does not exist.',
  invalid_reset_code: 'Invalid reset code',
  password_minimum_requirements: 'Your password must be a minimum of 8 characters and include at least one lowercase, one uppercase, and one numeric character.',
  passwords_must_match: 'Passwords must match',
  must_include_new_password_email: 'Must include new password and user email',
  must_include_new_password_confirmation_code: 'Must include new password and confirmationCode',
  cannot_send_reset_code_without_email: 'Cannot send reset code without email',
  must_enter_old_password: 'Must enter Old Password',
  must_enter_reset_code: 'Must enter Reset Code',
  must_enter_new_password: 'Must enter New Password',
  passwords_cannot_begin_or_end_with_spaces: 'Passwords cannot begin or end with spaces',

  // Server-side errors
  'User with that email already exists': "User with that email already exists",
  'Try another display name': "Try another display name",
  'Password cannot be a previously used password': "Password cannot be a previously used password",
  'Invalid reset code': "Invalid reset code",
  'Wrong username and password combination or the user does not exist.': "Wrong username and password combination or the user does not exist.",
  'Invalid code provided, please request a code again.': 'Invalid code provided, please request a code again.',
  'Password cannot begin or end with spaces': "Password cannot begin or end with spaces",
  'LimitExceededException - Attempt limit exceeded, please try after some time.': "LimitExceededException - Attempt limit exceeded, please try after some time.",
  'User is not Authorized': "User is not Authorized",
  'Your session timed out. Sign in again with your temporary password.': "Your session timed out. Sign in again with your temporary password.",
  'Internal Service Failure - Cognito Unavailable': "Internal Service Failure - Cognito Unavailable",
  'Internal Service Failure - Unknown Failure': "Internal Service Failure - Unknown Failure",
  'Must enter Reset Code': 'Must enter Reset Code',

  // Change Password Challenges
  set_password_challenge: 'You must set a new password the first time you sign in for security purposes.',
  reset_password_challenge: 'We sent a password reset code to [EMAIL]. Enter that code and a new password.',
  set_new_password_challenge: 'Your company&apos;s policy requires that your password expires after some time. We sent a password reset code to [EMAIL]. Enter that code and a new password.',
  change_your_password_challenge: 'Enter your current password and a new password below to change it.',
  change_password_challenge: 'Enter a new password for the user',
}

export const en_countries = {
  AF:	'Afghanistan',
  AX:	'Åland Islands',
  AL:	'Albania',
  DZ:	'Algeria',
  AS:	'American Samoa',
  AD:	'Andorra',
  AO:	'Angola',
  AI:	'Anguilla',
  AQ:	'Antarctica',
  AG:	'Antigua and Barbuda',
  AR:	'Argentina',
  AM:	'Armenia',
  AW:	'Aruba',
  AU:	'Australia',
  AT:	'Austria',
  AZ:	'Azerbaijan',
  BS:	'Bahamas',
  BH:	'Bahrain',
  BD:	'Bangladesh',
  BB:	'Barbados',
  BY:	'Belarus',
  BE:	'Belgium',
  BZ:	'Belize',
  BJ:	'Benin',
  BM:	'Bermuda',
  BT:	'Bhutan',
  BO:	'Bolivia (Plurinational State of)',
  BQ:	'Bonaire, Sint Eustatius and Saba',
  BA:	'Bosnia and Herzegovina',
  BW:	'Botswana',
  BV:	'Bouvet Island',
  BR:	'Brazil',
  IO:	'British Indian Ocean Territory',
  BN:	'Brunei Darussalam',
  BG:	'Bulgaria',
  BF:	'Burkina Faso',
  BI:	'Burundi',
  CV:	'Cabo Verde',
  KH:	'Cambodia',
  CM:	'Cameroon',
  CA:	'Canada',
  KY:	'Cayman Islands',
  CF:	'Central African Republic',
  TD:	'Chad',
  CL:	'Chile',
  CN:	'China',
  CX:	'Christmas Island',
  CC:	'Cocos (Keeling) Islands',
  CO:	'Colombia',
  KM:	'Comoros',
  CG:	'Congo',
  CD:	'Congo, Democratic Republic of the',
  CK:	'Cook Islands',
  CR:	'Costa Rica',
  CI:	"Côte d'Ivoire",
  HR:	'Croatia',
  CU:	'Cuba',
  CW:	'Curaçao',
  CY:	'Cyprus',
  CZ:	'Czechia',
  DK:	'Denmark',
  DJ:	'Djibouti',
  DM:	'Dominica',
  DO:	'Dominican Republic',
  EC:	'Ecuador',
  EG:	'Egypt',
  SV:	'El Salvador',
  GQ:	'Equatorial Guinea',
  ER:	'Eritrea',
  EE:	'Estonia',
  SZ:	'Eswatini',
  ET:	'Ethiopia',
  FK:	'Falkland Islands (Malvinas)',
  FO:	'Faroe Islands',
  FJ:	'Fiji',
  FI:	'Finland',
  FR:	'France',
  GF:	'French Guiana',
  PF:	'French Polynesia',
  TF:	'French Southern Territories',
  GA:	'Gabon',
  GM:	'Gambia',
  GE:	'Georgia',
  DE:	'Germany',
  GH:	'Ghana',
  GI:	'Gibraltar',
  GR:	'Greece',
  GL:	'Greenland',
  GD:	'Grenada',
  GP:	'Guadeloupe',
  GU:	'Guam',
  GT:	'Guatemala',
  GG:	'Guernsey',
  GN:	'Guinea',
  GW:	'Guinea-Bissau',
  GY:	'Guyana',
  HT:	'Haiti',
  HM:	'Heard Island and McDonald Islands',
  VA:	'Holy See',
  HN:	'Honduras',
  HK:	'Hong Kong',
  HU:	'Hungary',
  IS:	'Iceland',
  IN:	'India',
  ID:	'Indonesia',
  IR:	'Iran (Islamic Republic of)',
  IQ:	'Iraq',
  IE:	'Ireland',
  IM:	'Isle of Man',
  IL:	'Israel',
  IT:	'Italy',
  JM:	'Jamaica',
  JP:	'Japan',
  JE:	'Jersey',
  JO:	'Jordan',
  KZ:	'Kazakhstan',
  KE:	'Kenya',
  KI:	'Kiribati',
  KP:	"Korea (Democratic People's Republic of)",
  KR:	'Korea, Republic of',
  KW:	'Kuwait',
  KG:	'Kyrgyzstan',
  LA:	"Lao People's Democratic Republic",
  LV:	'Latvia',
  LB:	'Lebanon',
  LS:	'Lesotho',
  LR:	'Liberia',
  LY:	'Libya',
  LI:	'Liechtenstein',
  LT:	'Lithuania',
  LU:	'Luxembourg',
  MO:	'Macao',
  MG:	'Madagascar',
  MW:	'Malawi',
  MY:	'Malaysia',
  MV:	'Maldives',
  ML:	'Mali',
  MT:	'Malta',
  MH:	'Marshall Islands',
  MQ:	'Martinique',
  MR:	'Mauritania',
  MU:	'Mauritius',
  YT:	'Mayotte',
  MX:	'Mexico',
  FM:	'Micronesia (Federated States of)',
  MD:	'Moldova, Republic of',
  MC:	'Monaco',
  MN:	'Mongolia',
  ME:	'Montenegro',
  MS:	'Montserrat',
  MA:	'Morocco',
  MZ:	'Mozambique',
  MM:	'Myanmar',
  NA:	'Namibia',
  NR:	'Nauru',
  NP:	'Nepal',
  NL:	'Netherlands',
  NC:	'New Caledonia',
  NZ:	'New Zealand',
  NI:	'Nicaragua',
  NE:	'Niger',
  NG:	'Nigeria',
  NU:	'Niue',
  NF:	'Norfolk Island',
  MK:	'North Macedonia',
  MP:	'Northern Mariana Islands',
  NO:	'Norway',
  OM:	'Oman',
  PK:	'Pakistan',
  PW:	'Palau',
  PS:	'Palestine, State of',
  PA:	'Panama',
  PG:	'Papua New Guinea',
  PY:	'Paraguay',
  PE:	'Peru',
  PH:	'Philippines',
  PN:	'Pitcairn',
  PL:	'Poland',
  PT:	'Portugal',
  PR:	'Puerto Rico',
  QA:	'Qatar',
  RE:	'Réunion',
  RO:	'Romania',
  RU:	'Russian Federation',
  RW:	'Rwanda',
  BL:	'Saint Barthélemy',
  SH:	'Saint Helena, Ascension and Tristan da Cunha',
  KN:	'Saint Kitts and Nevis',
  LC:	'Saint Lucia',
  MF:	'Saint Martin (French part)',
  PM:	'Saint Pierre and Miquelon',
  VC:	'Saint Vincent and the Grenadines',
  WS:	'Samoa',
  SM:	'San Marino',
  ST:	'Sao Tome and Principe',
  SA:	'Saudi Arabia',
  SN:	'Senegal',
  RS:	'Serbia',
  SC:	'Seychelles',
  SL:	'Sierra Leone',
  SG:	'Singapore',
  SX:	'Sint Maarten (Dutch part)',
  SK:	'Slovakia',
  SI:	'Slovenia',
  SB:	'Solomon Islands',
  SO:	'Somalia',
  ZA:	'South Africa',
  GS:	'South Georgia and the South Sandwich Islands',
  SS:	'South Sudan',
  ES:	'Spain',
  LK:	'Sri Lanka',
  SD:	'Sudan',
  SR:	'Suriname',
  SJ:	'Svalbard and Jan Mayen',
  SE:	'Sweden',
  CH:	'Switzerland',
  SY:	'Syrian Arab Republic',
  TW:	'Taiwan, Province of China',
  TJ:	'Tajikistan',
  TZ:	'Tanzania, United Republic of',
  TH:	'Thailand',
  TL:	'Timor-Leste',
  TG:	'Togo',
  TK:	'Tokelau',
  TO:	'Tonga',
  TT:	'Trinidad and Tobago',
  TN:	'Tunisia',
  TR:	'Türkiye',
  TM:	'Turkmenistan',
  TC:	'Turks and Caicos Islands',
  TV:	'Tuvalu',
  UG:	'Uganda',
  UA:	'Ukraine',
  AE:	'United Arab Emirates',
  GB:	'United Kingdom of Great Britain and Northern Ireland',
  US:	'United States of America',
  UM:	'United States Minor Outlying Islands',
  UY:	'Uruguay',
  UZ:	'Uzbekistan',
  VU:	'Vanuatu',
  VE:	'Venezuela (Bolivarian Republic of)',
  VN:	'Viet Nam',
  VG:	'Virgin Islands (British)',
  VI:	'Virgin Islands (U.S.)',
  WF:	'Wallis and Futuna',
  EH:	'Western Sahara',
  YE:	'Yemen',
  ZM:	'Zambia',
  ZW:	'Zimbabwe',
}
